import { toast } from 'sonner';
import { FavHeart } from '../../icons';
import { useTranslations } from 'next-intl';
import { AiFillHeart } from 'react-icons/ai';
import useWishlist from '@/store/wishlist.store';
import { event_toggle_wishlist, update_wishlists_event } from '@/utils/gtm';
import ProductCardFavIcon from '../icons/product-card-fav-icon';

const AddToWishList = ({ product, isFromWishList }) => {
  const t = useTranslations('');
  const { wishlist, toggleWishlist, products } = useWishlist((state) => state);

  // Extract SKU to avoid redundant logic
  const productSku = product?.sku || product?.extension_attributes?.product_sku;
  const isInWishlist = Array.isArray(wishlist)
    ? wishlist?.includes(productSku)
    : false;

  const handleToggleWishlist = () => {
    if (!product) return;

    toggleWishlist(productSku, product);

    if (isInWishlist) {
      const filterdProducts = products.filter(
        (info) => info?.sku !== product?.sku
      );
      update_wishlists_event(filterdProducts);
      event_toggle_wishlist(product, 'remove_from_wishlist');
      toast.info(t('favorite.Removed from wishlist'));
    } else {
      update_wishlists_event([...products, product]);
      event_toggle_wishlist(product, 'add_to_wishlist');
      toast.success(t('favorite.Added to wishlist'));
    }
  };

  if (isFromWishList) {
    return (
      <button
        onClick={handleToggleWishlist}
        className='bg-primary flex size-9 cursor-pointer items-center justify-center rounded-lg max-lg:size-6.75 max-md:size-6.25'
      >
        <FavHeart className='size-5 max-md:size-4.25 max-sm:size-3.5' />
      </button>
    );
  }

  return (
    <button
      onClick={handleToggleWishlist}
      className={`mb-1 flex size-6 cursor-pointer items-center justify-center rounded-sm border ${isInWishlist ? 'bg-primary border-primary' : 'border-border bg-white'} max-md:shadow lg:size-7 lg:shadow`}
    >
      {isInWishlist ? (
        <AiFillHeart className='size-5 text-white max-md:size-4.25 max-sm:size-3.5' />
      ) : (
        <ProductCardFavIcon className='size-5 max-md:size-4.25 max-sm:size-3.5' />
      )}
    </button>
  );
};

export default AddToWishList;
